import { ElementType } from 'react';
import { useParams } from 'react-router-dom';

const WithRouterParams = ({ element: Element }: { element: ElementType }) => {
    const params = useParams();
    return <Element {...params} />;
};

export default WithRouterParams;
